import React from 'react';
import { formatNumber } from './utils';
import type { AnalyticsData } from './types';

interface SubscriptionChartProps {
  data: Pick<AnalyticsData, 'subscriptionActive' | 'subscriptionCanceled'>;
}

function Bar({ active, canceled }: { active: number; canceled: number }) {
  const total = active + canceled;
  const activePct = total > 0 ? (active / total) * 100 : 0;
  const canceledPct = total > 0 ? (canceled / total) * 100 : 0;
  return (
    <div className="relative bg-gray-200 rounded-full h-1.5 overflow-hidden">
      <div
        className="top-0 left-0 absolute bg-gradient-to-r from-emerald-500 to-teal-500 h-full transition-all duration-500"
        style={{ width: `${activePct}%` }}
      />
      <div
        className="top-0 left-0 absolute bg-gradient-to-r from-rose-500 to-pink-500 h-full transition-all duration-500"
        style={{ width: `${canceledPct}%`, left: `${activePct}%` }}
      />
    </div>
  );
}

export function SubscriptionChart({ data }: SubscriptionChartProps) {
  const { subscriptionActive, subscriptionCanceled } = data;
  return (
    <div className="flex flex-col bg-white p-1.5 border border-gray-200 rounded min-w-0 min-h-0">
      <div className="flex justify-between items-center gap-0.5 mb-0.5 shrink-0">
        <h3 className="font-semibold text-[10px] text-gray-900">Subs</h3>
        <div className="flex items-center gap-1">
          <span className="text-[9px] text-gray-600">●Active</span>
          <span className="text-[9px] text-gray-600">●Canceled</span>
        </div>
      </div>

      <Bar active={subscriptionActive} canceled={subscriptionCanceled} />

      <div className="flex-1 gap-1 grid grid-cols-2 mt-1 min-h-0">
        <div className="bg-emerald-50 p-1 rounded min-w-0 text-center">
          <p className="font-bold text-gray-900 text-xs leading-tight">{formatNumber(subscriptionActive)}</p>
          <p className="text-[9px] text-emerald-600">Active</p>
        </div>
        <div className="bg-rose-50 p-1 rounded min-w-0 text-center">
          <p className="font-bold text-gray-900 text-xs leading-tight">{formatNumber(subscriptionCanceled)}</p>
          <p className="text-[9px] text-rose-600">Canceled</p>
        </div>
      </div>
    </div>
  );
}
